import { Component } from '@angular/core';
import moment from 'moment';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { ErrorlogService } from '@services/errorlog/errorlog.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-errorlog',
    templateUrl: './errorlog.component.html',
    styleUrls: ['./errorlog.component.scss'],
    providers: [ErrorlogService],
    standalone: false
})
export class ErrorlogComponent {

  public title = 'Errorlog';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'method', name: 'Method' },
    { prop: 'code', name: 'Error Code' },
    {
      prop: 'created', name: 'Created', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    { prop: 'message', name: 'Message' }
  ];

  params: any = {
    $sort: {
      created: -1
    }
  };

  constructor(
    public errorlogService: ErrorlogService,
    private router: Router
  ) {
  }

  onDetail(event: DataTableEvent) {
    this.router.navigate(['errorlog/', event.row._id]);
  }

}
